import axios from "axios";
import { t } from "i18next";
import _ from "lodash";

import AlertsService from "services/alerts-service";

import { mergeStorage, omitStorage, putStorage } from "hooks/useStorage";

const LabsApi = {
    getLabs: async () => {
        try {
            const { data: response } = (await axios.get(`/labs/all`)) as any;
            mergeStorage(`labs`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("g2n1dh29d"));
        }
    },
    getMyUniversityLabs: async () => {
        try {
            const { data: response } = (await axios.get(`/labs/my`)) as any;
            mergeStorage(`labs`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("5dwj1hcfm7"));
        }
    },
    createLab: async (details: any) => {
        try {
            const { data: response } = (await axios.post(`/labs`, { details })) as any;
            await LabsApi.getMyUniversityLabs();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("k5ln03yumcd"));
        }
    },
    updateLab: async (lab: { id: string; universityId: string; [key: string]: any }) => {
        try {
            const { data: response } = (await axios.put(`/labs`, lab)) as any;
            await LabsApi.getMyUniversityLabs();
            putStorage(`labs.${lab.id}`, response);
            AlertsService.showSuccess(`Объект научной инфраструктуры успешно создан`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("qlzwjpqp9v"));
        }
    },
    deleteLab: async (labId: string) => {
        try {
            await axios.delete(`/labs/${labId}`);
            omitStorage(`labs.${labId}`);
            AlertsService.showSuccess(`Объект научной инфраструктуры успешно удален`);
            return;
        } catch (error) {
            throw AlertsService.showError(t("kmwan0ovhi8"));
        }
    },
    getLabInfo: async (id: string) => {
        try {
            const { data: response } = (await axios.get(`/labs/${id}`)) as any;
            mergeStorage(`labs.${id}`, response);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("2n76eiz4zdz"));
        }
    },
};

export default LabsApi;
